import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtDriveFolder } from "server/models"
import { IDLE, PENDING, LIST, BLOCKS } from "const"
import { deepCopy } from "client/utils"
import {
    StoreType,
    DriveFolder,
    DriveFile,
    RenameDriveFolder,
    SaveDriveFile,

    setDriveAction,

    setDriveFolderListLoadState,
    setDriveFolderList,
    setDriveFolderActive,
    setDriveFolderSelected,

    setDriveFileListLoadState,
    setDriveFileList,
    setDriveFileActive,
    setDriveFileSelected,

    parseName,
    createFileName,
    createRecycleFileName,
    createFolderName,
    createDriveUrl,
} from "client/store"
import { BalloonMessage } from "client/components"
import { RenameInput } from "./styled"

let resultName: string
const Rename = () => {
    const drivePath = useSelector((state: StoreType) => state.drive.drivePath)
    const baseRoute = useSelector((state: StoreType) => state.drive.baseRoute)
    const listStyle = useSelector((state: StoreType) => state.drive.listStyle)

    const folderActive = useSelector((state: StoreType) => state.drive.folder.active)
    const foldersSelected = useSelector((state: StoreType) => state.drive.folder.selected)
    const folderList = useSelector((state: StoreType) => state.drive.folder.folderList)

    const fileActive = useSelector((state: StoreType) => state.drive.file.active)
    const filesSelected = useSelector((state: StoreType) => state.drive.file.selected)
    const fileList = useSelector((state: StoreType) => state.drive.file.fileList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [newName, setNewName] = useState("")

    const singleFolderSelected = foldersSelected.length === 1 && filesSelected.length === 0
    const singleFileSelected = foldersSelected.length === 0 && filesSelected.length === 1

    const folder = folderActive || (singleFolderSelected && foldersSelected[0])
    const file = fileActive || (singleFileSelected && filesSelected[0])

    useEffect(() => {
        // create start value
        let name = ""
        if (folder) name = createFolderName(folder)
        if (file) name = createFileName(file)
        resultName = name
        setNewName(name)

        // focus on input
        const input = document.querySelector(RenameInput) as HTMLInputElement
        input.focus()
        setTimeout(() => {
            // without timeout the value in input is empty
            input.setSelectionRange(0, input.value.length)
        }, 100)
    }, [])

    const save = () => {
        if (folder) saveFolder()
        if (file) saveFile()
    }

    const saveFolder = () => {
        const { name, counter } = parseName(resultName)
        if (name === folder.name && counter === folder.copy) {
            dispatch(setDriveAction(null))
            return
        }

        dispatch(setDriveFolderListLoadState(PENDING))
        const folderData: DriveFolder = {
            ...folder,
            name,
            copy: counter,
        }
        RenameDriveFolder(folderData, lang)
        .then((res) => {
            if (res.validation) {
                BalloonMessage(res.validation.name)
            } else {
                const newDrivePath: MtDriveFolder[] = deepCopy(drivePath)
                newDrivePath.push(folderData)

                const newFolderList: DriveFolder[] = deepCopy(folderList)
                for (let i = 0; i < newFolderList.length; i++) {
                    const obj = newFolderList[i]
                    if (obj.id === folder.id) {
                        newFolderList[i] = {
                            ...folderData,
                            url: createDriveUrl(newDrivePath, baseRoute),
                            path: newDrivePath,
                        }
                        break
                    }
                }
                dispatch(setDriveFolderList(newFolderList))
                dispatch(setDriveFolderActive(null))
                dispatch(setDriveFolderSelected([]))
            }
            dispatch(setDriveFolderListLoadState(IDLE))
            dispatch(setDriveAction(null))
        })
    }

    const saveFile = () => {
        const { name, counter } = parseName(resultName)
        if (name === file.name && counter === file.copy) {
            dispatch(setDriveAction(null))
            return
        }

        dispatch(setDriveFileListLoadState(PENDING))
        const fileData: DriveFile = {
            ...file,
            name,
            copy: counter,
        }
        SaveDriveFile(fileData, lang)
        .then((res) => {
            if (res.validation) {
                BalloonMessage(res.validation.name)
            } else {
                const folderUrl = createDriveUrl(drivePath, baseRoute)
                const fileNameUrl = fileData.folderId === null
                    ? createRecycleFileName(fileData)
                    : createFileName(fileData)

                const newFileList: DriveFile[] = deepCopy(fileList)
                for (let i = 0; i < newFileList.length; i++) {
                    const obj = newFileList[i]
                    if (obj.id === file.id) {
                        newFileList[i] = {
                            ...fileData,
                            url: `${folderUrl}/${encodeURIComponent(fileNameUrl)}`,
                        }
                        break
                    }
                }
                dispatch(setDriveFileList(newFileList))
                dispatch(setDriveFileActive(null))
                dispatch(setDriveFileSelected([]))
            }
            dispatch(setDriveFileListLoadState(IDLE))
            dispatch(setDriveAction(null))
        })
    }

    const onKeyDown = (e: React.KeyboardEvent) => {
        if (e.code === "Escape") { // cancel rename
            dispatch(setDriveAction(null))
        }
        if (e.code === "Enter") {
            save()
        }
    }

    return (
        <RenameInput
            blockView={listStyle === BLOCKS}
            listView={listStyle === LIST}
            type="text"
            value={newName}
            onChange={(e) => {
                const name = e.target.value
                resultName = name
                setNewName(name)
            }}
            onKeyDown={onKeyDown}
        />
    )
}
export default Rename
